<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.users") }}</h3>
            </div>
            <div class="card-body">
                <button
                    class="btn btn-sm btn-primary mb-3"
                    @click="openUserModal()"
                >
                    <span class="text-white fs-6 fw-bold">{{ $t("user.add") }}</span>
                </button>

                <table class="table table-sm table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("user.firstName") }}</th>
                            <th>{{ $t("user.username") }}</th>
                            <th>{{ $t("user.phone") }}</th>
                            <th>{{ $t("user.function") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="users.length">
                        <tr v-for="user in paginatedUsers" :key="user.id" class="align-middle">
                            <td>{{ user.first_name }} {{ user.last_name }}</td>
                            <td>{{ user.username }}</td>
                            <td>{{ user.phone || "--" }}</td>
                            <td>{{ user.function }}</td>
                            <td>
                                <button
                                    class="btn btn-secondary btn-sm me-2"
                                    @click="openUserModal(user)"
                                >
                                    <icon icon="EditPen"></icon>
                                </button>
                                <button class="btn btn-danger btn-sm" @click="deleteUser(user)">
                                    <icon icon="Trash"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="5" class="text-center text-muted py-3">
                                {{ $t("user.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="users.length >= 5" class="d-flex justify-content-between mx-4">
                    <Paginate
                        :page-count="totalPages"
                        :click-handler="(p) => currentPage = p"
                        :prev-text="'«'"
                        :next-text="'»'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :active-class="'active'"
                        :disabled-class="'disabled'"
                    />
                    <div class="flex-shrink-0">
                        <select v-model="perPage" class="form-select form-select-sm" style="height: 40px;">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="25">20</option>
                            <option :value="50">50</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="userModal" tabindex="-1" aria-hidden="true" ref="userModal">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">{{ userModalTitle }}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form class="row g-3" ref="form">
                        <div v-if="!isEditing" class="d-flex">
                            <div class="form-check col-6">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="userType"
                                    id="newUser"
                                    v-model="userType"
                                    value="new"
                                />
                                <label class="form-check-label" for="newUser">
                                    {{ $t("user.new") }}
                                </label>
                            </div>
                            <div class="form-check col-6">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="userType"
                                    id="existingUser"
                                    v-model="userType"
                                    value="existing"
                                />
                                <label class="form-check-label" for="existingUser">
                                    {{ $t("user.existing") }}
                                </label>
                            </div>
                        </div>


                        <!-- Form for new user -->
                        <div class="row col-12 mt-3" v-if="userType === 'new'">
                            <div class="col-md-6">
                                <label for="first_name" class="form-label fw-bold">{{ $t("user.firstName") }} *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="first_name"
                                    v-model="user.first_name"
                                    required
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="last_name" class="form-label fw-bold">{{ $t("user.lastName") }} *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="last_name"
                                    v-model="user.last_name"
                                    required
                                />
                            </div>
                            <div class="col-12">
                                <label for="email" class="form-label fw-bold">{{ $t("user.email") }} *</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    id="email"
                                    v-model="user.email"
                                    required
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="phone" class="form-label">{{ $t("user.phone") }}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="phone"
                                    v-model="user.phone"
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="function" class="form-label fw-bold">{{ $t("user.function") }} *</label>
                                <select
                                    id="function"
                                    class="form-select"
                                    v-model="user.function_id"
                                    required
                                >
                                    <option disabled value="">Zvolte...</option>
                                    <option
                                        v-for="fn in functions"
                                        :key="fn.id"
                                        :value="fn.id"
                                    >
                                        {{ $t("functions." + fn.name) }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="row" v-else-if="userType === 'edit'">
                            <div class="col-12">
                                <label for="email" class="form-label fw-bold">{{ $t("user.email") }} *</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    id="email"
                                    v-model="user.email"
                                    required
                                />
                            </div>
                            <div class="col-12">
                                <label for="function" class="form-label fw-bold">{{ $t("user.function") }} *</label>
                                <select
                                    id="function"
                                    class="form-select"
                                    v-model="user.function_id"
                                    required
                                >
                                    <option disabled value="">Zvolte...</option>
                                    <option
                                        v-for="fn in functions"
                                        :key="fn.id"
                                        :value="fn.id"
                                    >
                                        {{ $t("functions." + fn.name) }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary text-white fs-6 fw-bold" @click="saveUser">
                        {{ $t("utils.save") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { Modal } from 'bootstrap';
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Icon,
        Paginate,
    },
    data() {
        return {
            functions: [],
            users: [],
            userModal: null,
            userModalTitle: null,
            isEditing: false,
            user: {
                username: "",
                email: "",
                first_name: "",
                last_name: "",
                password: "",
                phone: "",
                function_id: "",
            },
            userType: "new",
            currentPage: 1,
            perPage: 10,
        }
    },
    computed: {
        paginatedUsers() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.users.slice(start, start + this.perPage);
        },
        totalPages() {
            return Math.ceil(this.users.length / this.perPage);
        }
    },
    created() {
        this.getUsers();
        this.getFunctions();
    },
    mounted() {
        this.userModal = new Modal(this.$refs.userModal);
    },
    methods: {
        getFunctions() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/functions`)
            .then(res => {
                this.functions = res.data;
            })
            .catch(error => {
                console.error("Error loading functions.", error);
            });
        },
        getUsers() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/users`)
            .then(res => {
                this.users = res.data;
            })
            .catch(error => {
                console.error("Error loading users.", error);
            });
        },
        openUserModal(user) {
            if (user) {
                this.userModalTitle = this.$t("user.edit")
                this.user = {...user};
                this.isEditing = true;
            } else {
                this.userModalTitle = this.$t("user.add")
                this.user = {
                    username: "",
                    email: "",
                    first_name: "",
                    last_name: "",
                    password: "",
                    phone: "",
                    function_id: "",
                }
                this.isEditing = false;
            }
            this.userModal.show();
        },
        validateData() {
            if (this.$refs.form.checkValidity() === false){
                this.$refs.form.reportValidity();
                return false;
            }
            return true;
        },
        saveUser() {
            if (!this.validateData()) return;

            if(this.isEditing) {
                // EIDT
                this.$store.getters.api.patch(`dashboard/${this.$route.params.slug}/users/${this.user.user_id}/edit`, this.user)
                .then(() => {
                    this.getUsers();
                    this.userModal.hide();
                })
                .catch(error => {
                    console.error("Error updating user.", error);
                });
            } else {
                // ADD
                this.$store.getters.api.post(`/dashboard/${this.$route.params.slug}/users/add`,
                    {
                        ...this.user,
                        "user_type": this.userType
                    }
                )
                .then(() => {
                    this.getUsers();
                    this.userModal.hide();
                })
                .catch(error => {
                    console.error("Error creating user.", error);
                });
            }
        },
    }
}
</script>

<style scoped>
.modal_wrapper {
  background-color: #fff;
}
</style>